// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\core\Enums\Errors\AuthError
// Generated on: <normalized>

export enum AuthError {
  DEFAULT = 'serverError',
  ACCESS_DENIED = 'ACCESS_DENIED',
  REQUEST_NOT_ALLOCATED = 'REQUEST_NOT_ALLOCATED',
  INVALID_ENTRY_ENDPOINT = 'INVALID_ENTRY_ENDPOINT',
  API_LEDGER_ERROR_FETCH_FAIL = 'API_LEDGER_ERROR_FETCH_FAIL',
  API_LEDGER_SERVICE_TYPE_ALLOCATION_FAIL = 'API_LEDGER_SERVICE_TYPE_ALLOCATION_FAIL',
  INVALID_AUTH_ROLE = 'INVALID_AUTH_ROLE',
  TOKEN_NOT_SET = 'TOKEN_NOT_SET',
  NO_URI_SEGS = 'NO_URI_SEGS',
  NO_PERMISSIONS_FOUND_FOR_ROLE = 'NO_PERMISSIONS_FOUND_FOR_ROLE',
  NO_PERMISSION_DATA_SET = 'NO_PERMISSION_DATA_SET',
  NO_ROUTES_FOUND = 'NO_ROUTES_FOUND',
  NO_VALID_ROUTE = 'NO_VALID_ROUTE',
  SEGMENT_VALIDATION_FAILED = 'SEGMENT_VALIDATION_FAILED',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  UNEXPECTED_SESSION_RESPONSE = 'UNEXPECTED_SESSION_RESPONSE',
  API_HEADER_REQUIRED = 'API_HEADER_REQUIRED',
  API_GUID_URI_SEGMENT_NOT_VALID = 'API_GUID_URI_SEGMENT_NOT_VALID',
  AUTH_HEADER_REQUIRED = 'AUTH_HEADER_REQUIRED',
  INVALID_REQUEST = 'INVALID_REQUEST',
  API_GUID_NOT_SET = 'API_GUID_NOT_SET',
  API_URI_ERROR = 'API_URI_ERROR',
  API_HEADER_ERROR = 'API_HEADER_ERROR',
  AUTH_HEADER_ERROR = 'AUTH_HEADER_ERROR',
  NO_SESSION_FOUND_INVALID_TOKEN = 'NO_SESSION_FOUND_INVALID_TOKEN',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  RENEW_TOKEN_FAILED = 'RENEW_TOKEN_FAILED',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_GATEWAY_ERROR = 'USER_GATEWAY_ERROR',
  USER_NO_PASSWORD = 'USER_NO_PASSWORD',
  USER_NO_ROLE = 'USER_NO_ROLE',
  USER_INVALID_PASSWORD = 'USER_INVALID_PASSWORD',
  USER_LOGIN_DISABLED = 'USER_LOGIN_DISABLED',
  USER_JWT_TOKEN_FAILED = 'USER_JWT_TOKEN_FAILED',
  SESSION_CREATION_FAILED = 'SESSION_CREATION_FAILED',
  SESSION_RENEWAL_FAILED = 'SESSION_RENEWAL_FAILED',
  ROLE_NOT_FOUND = 'ROLE_NOT_FOUND',
  ROLE_DOES_NOT_EXIST = 'ROLE_DOES_NOT_EXIST',
  TENANT_SWITCH_UNAUTHORIZED = 'TENANT_SWITCH_UNAUTHORIZED',
  COULDNT_FETCH_APP_CONFIG = 'COULDNT_FETCH_APP_CONFIG',
  REQUIRED_VS_SENT_URI_SEGMENTS_NOT_IDENTICAL = 'REQUIRED_VS_SENT_URI_SEGMENTS_NOT_IDENTICAL',
}

export const AuthErrorCases = ["serverError", "ACCESS_DENIED", "REQUEST_NOT_ALLOCATED", "INVALID_ENTRY_ENDPOINT", "API_LEDGER_ERROR_FETCH_FAIL", "API_LEDGER_SERVICE_TYPE_ALLOCATION_FAIL", "INVALID_AUTH_ROLE", "TOKEN_NOT_SET", "NO_URI_SEGS", "NO_PERMISSIONS_FOUND_FOR_ROLE", "NO_PERMISSION_DATA_SET", "NO_ROUTES_FOUND", "NO_VALID_ROUTE", "SEGMENT_VALIDATION_FAILED", "AUTHENTICATION_FAILED", "UNEXPECTED_SESSION_RESPONSE", "API_HEADER_REQUIRED", "API_GUID_URI_SEGMENT_NOT_VALID", "AUTH_HEADER_REQUIRED", "INVALID_REQUEST", "API_GUID_NOT_SET", "API_URI_ERROR", "API_HEADER_ERROR", "AUTH_HEADER_ERROR", "NO_SESSION_FOUND_INVALID_TOKEN", "SESSION_EXPIRED", "RENEW_TOKEN_FAILED", "USER_NOT_FOUND", "USER_GATEWAY_ERROR", "USER_NO_PASSWORD", "USER_NO_ROLE", "USER_INVALID_PASSWORD", "USER_LOGIN_DISABLED", "USER_JWT_TOKEN_FAILED", "SESSION_CREATION_FAILED", "SESSION_RENEWAL_FAILED", "ROLE_NOT_FOUND", "ROLE_DOES_NOT_EXIST", "TENANT_SWITCH_UNAUTHORIZED", "COULDNT_FETCH_APP_CONFIG", "REQUIRED_VS_SENT_URI_SEGMENTS_NOT_IDENTICAL"] as const;
